import React, { Component } from 'react'

export class TeamSvg extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={45}
                height={45}
                fill="none"

            >
                <path fill="#0064FB" d="M22.5 14.25a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z" />
                <path
                    fill="#2E2F46"
                    d="M22.5 15a5.256 5.256 0 0 1-5.25-5.25A5.256 5.256 0 0 1 22.5 4.5a5.256 5.256 0 0 1 5.25 5.25A5.256 5.256 0 0 1 22.5 15Zm0-9c-2.07 0-3.75 1.68-3.75 3.75 0 2.07 1.68 3.75 3.75 3.75 2.07 0 3.75-1.68 3.75-3.75C26.25 7.68 24.57 6 22.5 6Z"
                />
                <path
                    fill="#0064FB"
                    d="m25.455 17.31 3.083.84a2.996 2.996 0 0 1 2.212 2.895v6.705h-16.5v-6.705c0-1.358.908-2.543 2.212-2.895l3.083-.84L22.5 21l2.955-3.69Z"
                />
                <path
                    fill="#2E2F46"
                    d="M30.75 28.5h-16.5a.752.752 0 0 1-.75-.75v-6.705c0-1.688 1.14-3.18 2.767-3.623l3.083-.84a.756.756 0 0 1 .78.255L22.5 19.8l2.37-2.963a.756.756 0 0 1 .78-.255l3.083.84a3.758 3.758 0 0 1 2.767 3.623v6.705c0 .413-.337.75-.75.75ZM15 27h15v-5.955a2.248 2.248 0 0 0-1.657-2.168l-2.61-.712-2.648 3.308c-.285.352-.885.352-1.17 0l-2.648-3.308-2.61.713A2.25 2.25 0 0 0 15 21.052V27Z"
                />
                <path
                    fill="#2E2F46"
                    d="M27 28.5a.752.752 0 0 1-.75-.75v-3c0-.413.337-.75.75-.75s.75.337.75.75v3c0 .413-.337.75-.75.75ZM18 28.5a.752.752 0 0 1-.75-.75v-3c0-.413.337-.75.75-.75s.75.337.75.75v3c0 .413-.337.75-.75.75ZM37.5 36a.752.752 0 0 1-.75-.75v-8.235c0-2.483-2.017-4.5-4.5-4.5h-1.5a.752.752 0 0 1-.75-.75c0-.413.337-.75.75-.75h1.5c3.307 0 6 2.692 6 6v8.235c0 .413-.337.75-.75.75Z"
                />
                <path
                    fill="#fff"
                    d="M37.5 39.75a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z"
                />
                <path
                    fill="#2E2F46"
                    d="M37.5 40.5a3 3 0 1 1 0-6 3 3 0 1 1 0 6Zm0-4.5c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5 1.5-.675 1.5-1.5-.675-1.5-1.5-1.5Z"
                />
                <path
                    fill="#fff"
                    d="M22.5 39.75a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z"
                />
                <path
                    fill="#2E2F46"
                    d="M22.5 40.5a3 3 0 1 1 0-6 3 3 0 1 1 0 6Zm0-4.5c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5 1.5-.675 1.5-1.5-.675-1.5-1.5-1.5ZM7.5 36a.752.752 0 0 1-.75-.75v-8.235c0-3.308 2.693-6 6-6h1.5c.412 0 .75.337.75.75 0 .412-.338.75-.75.75h-1.5a4.504 4.504 0 0 0-4.5 4.5v8.235c0 .413-.338.75-.75.75Z"
                />
                <path
                    fill="#fff"
                    d="M7.5 39.75a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z"
                />
                <path
                    fill="#2E2F46"
                    d="M7.5 40.5a3 3 0 1 1 0-6 3 3 0 1 1 0 6Zm0-4.5c-.825 0-1.5.675-1.5 1.5S6.675 39 7.5 39 9 38.325 9 37.5 8.325 36 7.5 36ZM22.5 36a.752.752 0 0 1-.75-.75v-7.5c0-.413.337-.75.75-.75s.75.337.75.75v7.5c0 .413-.337.75-.75.75Z"
                />
            </svg>
        )
    }
}

export default TeamSvg